import React from "react";

export default function NoPage() {
    return(
        <div className="App-content">
            <h1>404</h1>
            <p>Oh Sheet! Page not Found</p>
        </div>
    );
}